import {TweenMax, TimelineLite} from 'gsap/all';
import vars from '../helpers';

const $animate = $('.js-animate');

const $container = $('.main');

let scrollbar = false;

let resizeTimeout = null;

const init = () => {
	scrollbar = window.Scrollbar.init($container.find('.js-scroller').get(0), {
		damping: 0.1,
		renderByPixels: true,
		alwaysShowTracks: false,
		syncCallbacks: true,
	});

	$container.find('.js-scroller').addClass('is-inited');
}

const destroy = () => {
	if (scrollbar) {
		scrollbar.destroy();
		$container.find('.js-scroller').removeAttr('data-scrollbar tabindex style').removeClass('is-inited');
		scrollbar = false;
	}
}

vars.$window.on('resize', () => {
	if (resizeTimeout) {
		clearTimeout(resizeTimeout);
	}

	resizeTimeout = setTimeout(() => {
		if (!vars.isMobile()) {
			if (!scrollbar) {
				init();
			}
		} else if(scrollbar) {
			destroy();
		}
	}, 500);
});

if (!vars.isMobile()) {
	init();
}

$animate.each((index, item) => {
	const $item = $(item);

	let animation = null;

	switch ($item.data('type')) {
		case 'intro':
			if (vars.isMobile()) {
				animation = new TimelineLite({
					paused: true,
					onStart() {
						$item.removeClass('is-vhidden');
					},
				}).from($('.intro__title__name > span'), 0.5, {
					opacity: 0,
					x: -100,
				}).from($('.intro__title__label > span'), 0.5, {
					opacity: 0,
					x: -100,
				}, "-=0.25").from($('.intro__title__wear.for-mobile'), 0.5, {
					opacity: 0,
					x: -100,
				}, "-=0.25").from($('.intro__title__wear.for-mobile .intro__title__wear__circle'), 0.5, {
					opacity: 0,
					x: -100,
				}, "-=0.25").from($('.intro__persons__item--1 .intro__persons__item__image'), 0.5, {
					opacity: 0,
					x: -100,
				}, "-=0.25").from($('.intro__persons__item--1 .intro__persons__item__name'), 0.5, {
					opacity: 0,
					x: -100,
				}, "-=0.25").from($('.intro__persons__item--2 .intro__persons__item__image'), 0.5, {
					opacity: 0,
					x: 100,
				}, "-=0.25").from($('.intro__persons__item--2 .intro__persons__item__name'), 0.5, {
					opacity: 0,
					x: 100,
				}, "-=0.25").from($('.intro__persons__item--3 .intro__persons__item__image'), 0.5, {
					opacity: 0,
					x: -100,
				}, "-=0.25").from($('.intro__persons__item--3 .intro__persons__item__name'), 0.5, {
					opacity: 0,
					x: -100,
				}, "-=0.25");
			} else {
				animation = new TimelineLite({
					paused: true,
					onStart() {
						$item.removeClass('is-vhidden');
					},
				}).from($('.intro__title__name > span'), 0.5, {
					opacity: 0,
					x: -100,
				}).from($('.intro__title__label > span'), 0.5, {
					opacity: 0,
					x: -100,
				}, "-=0.25").from($('.intro__image.intro__image--1'), 0.5, {
					opacity: 0,
					y: 100,
				}, "-=0.35").from($('.intro__image.intro__image--2'), 0.5, {
					opacity: 0,
					y: 100,
				}, "-=0.35").from($('.intro__image.intro__image--3'), 0.5, {
					opacity: 0,
					y: 100,
				}, "-=0.25").from($('.intro__title__wear.for-desktop'), 0.5, {
					opacity: 0,
					y: -100,
				}, "-=0.3").from($('.intro__title__wear.for-desktop .intro__title__wear__circle'), 0.5, {
					opacity: 0,
					y: -100,
				}, "-=0.25").from($('.intro__text.for-desktop'), 0.5, {
					opacity: 0,
					y: 100,
				}, "-=0.25");
			}

			break;
		case 'intro-names':
			animation = new TimelineLite({
				paused: true,
			}).from($item, 0.4, {
				opacity: 0,
				y: 100,
			});
			$item.find('li').each((nIndex, nItem) => {
				animation.from($(nItem).find('span'), 0.4, {
					opacity: 0,
					y: 100,
				}, "-=0.25");
			});
			break;
		case 'left':
			animation = TweenMax.from($item, 0.7, {
				opacity: 0,
				x: 100,
				paused: true,
			});
			break;

		case 'question':
			if (vars.isMobile()) {
				animation = new TimelineLite({
					paused: true,
				}).from($item.find('.case__question__title'), 0.7, {
					opacity: 0,
					y: 100,
				}).from($item.find('.case__question__text'), 0.7, {
					opacity: 0,
					y: 100,
				}, "-=0.35");
			} else {
				vars.$window.on('load', () => {
					animation = new TimelineLite({
						paused: true,
					}).from($item.find('.case__question__title__line'), 0.3, {
						height: 0,
					}).from($item.find('.case__question__title__text span'), 0.7, {
						x: '-110%',
					}).from($item.find('.case__question__text'), 0.7, {
						opacity: 0,
						y: 100,
					});
				})
			}
			break;
		default:
			animation = TweenMax.from($item, 0.7, {
				opacity: 0,
				y: 100,
				paused: true,
			});
			break;
	}

	$item.on('inview', (event, isInView) => {
		if (isInView) {
			if (animation) {
				animation.play();
				$item.off('inview');
			}
		}
	});
});
